import * as SharedTrackingEvents from 'rich-text-lib/constants/usageTracking';

// hsimage
export const OPEN_IMAGE_PICKER = SharedTrackingEvents.OPEN_IMAGE_PICKER;
export const INSERT_IMAGE = SharedTrackingEvents.INSERT_IMAGE;
export const REPLACE_IMAGE = SharedTrackingEvents.REPLACE_IMAGE;
export const EDIT_IMAGE = SharedTrackingEvents.EDIT_IMAGE;
export const AUTOMATIC_IMAGE_UPLOAD = SharedTrackingEvents.AUTOMATIC_IMAGE_UPLOAD;
export const AUTOMATIC_IMAGE_UPLOAD_NOT_ALLOWED = 'automatic-image-upload-not-allowed';

// hsformatting
export const CHANGE_FONT_SIZE = SharedTrackingEvents.CHANGE_FONT_SIZE;
export const CHANGE_FONT = SharedTrackingEvents.CHANGE_FONT;
export const CHANGE_LINE_HEIGHT = SharedTrackingEvents.CHANGE_LINE_HEIGHT;
export const CHANGE_BLOCK_FORMAT = SharedTrackingEvents.CHANGE_BLOCK_FORMAT;
export const ESCAPE_BLOCK_FORMAT = SharedTrackingEvents.ESCAPE_BLOCK_FORMAT;

// hslink
export const INSERT_LINK = SharedTrackingEvents.INSERT_LINK;

// hsfilelink
export const INSERT_LINK_TO_FILE = SharedTrackingEvents.INSERT_LINK_TO_FILE;

// hsdatatokens
export const INSERT_PERSONALIZATION_TOKEN = SharedTrackingEvents.INSERT_PERSONALIZATION_TOKEN;
export const EDIT_PERSONALIZATION_TOKEN = SharedTrackingEvents.EDIT_PERSONALIZATION_TOKEN;
export const PERSONALIZATION_TOKEN_CASING = 'personalization-token-casing';

// hscta
export const OPEN_CTA_PICKER = SharedTrackingEvents.OPEN_CTA_PICKER;
export const INSERT_CTA = SharedTrackingEvents.INSERT_CTA;
export const UPDATE_CTA = SharedTrackingEvents.UPDATE_CTA;
export const EDIT_CTA = SharedTrackingEvents.EDIT_CTA;

// hsmedia
export const OPEN_EMBED_MODAL = SharedTrackingEvents.OPEN_EMBED_MODAL;
export const INSERT_MEDIA_EMBED = SharedTrackingEvents.INSERT_MEDIA_EMBED;
export const EDIT_MEDIA_EMBED = SharedTrackingEvents.EDIT_MEDIA_EMBED;

// hsvideo
export const OPEN_VIDEO_PICKER = SharedTrackingEvents.OPEN_VIDEO_PICKER;
export const INSERT_HUBSPOT_VIDEO = SharedTrackingEvents.INSERT_HUBSPOT_VIDEO;
export const EDIT_HUBSPOT_VIDEO = SharedTrackingEvents.EDIT_HUBSPOT_VIDEO;

// hsrsstokens
export const INSERT_RSS_TOKEN = SharedTrackingEvents.INSERT_RSS_TOKEN;
export const OPEN_RSS_TOKEN = SharedTrackingEvents.OPEN_RSS_TOKEN;

// hscode
export const EDIT_SOURCE_CODE = SharedTrackingEvents.EDIT_SOURCE_CODE;

// hscolor
export const OPEN_COLOR_POPOVER = SharedTrackingEvents.OPEN_COLOR_POPOVER;
export const RESET_COLOR_TO_DEFAULT = SharedTrackingEvents.RESET_COLOR_TO_DEFAULT;
export const CHANGE_COLOR_POPOVER_MODE = SharedTrackingEvents.CHANGE_COLOR_POPOVER_MODE;
export const APPLY_COLOR_POPOVER = SharedTrackingEvents.APPLY_COLOR_POPOVER;

// hsemoji
export const OPEN_EMOJI_POPOVER = SharedTrackingEvents.OPEN_EMOJI_POPOVER;
export const INSERT_EMOJI = SharedTrackingEvents.INSERT_EMOJI;

// hssnippet
export const OPEN_SNIPPET_POPOVER = SharedTrackingEvents.OPEN_SNIPPET_POPOVER;
export const INSERT_SNIPPET = SharedTrackingEvents.INSERT_SNIPPET;

// hstable
export const INSERT_TABLE = SharedTrackingEvents.INSERT_TABLE;
export const EDIT_TABLE = SharedTrackingEvents.EDIT_TABLE;

// hspaste
const PASTE_CONTENT = SharedTrackingEvents.PASTE_CONTENT;
export const CHOOSE_GOOGLE_TO_HTML_PASTE_OPTION = 'choose-google-to-html-paste-option';

// hsanchor
export const INSERT_TEMP_ANCHOR = SharedTrackingEvents.INSERT_TEMP_ANCHOR;
export const INSERT_ANCHOR = SharedTrackingEvents.INSERT_ANCHOR;
export const EDIT_ANCHOR = SharedTrackingEvents.EDIT_ANCHOR;
export const DRAG_DROP_ANCHOR = SharedTrackingEvents.DRAG_DROP_ANCHOR;

// hsvisualblocks
export const TOGGLE_VISUAL_BLOCKS = SharedTrackingEvents.TOGGLE_VISUAL_BLOCKS;

// hscallout
export const INSERT_CALLOUT = SharedTrackingEvents.INSERT_CALLOUT;
export const EDIT_CALLOUT = SharedTrackingEvents.EDIT_CALLOUT;

// hsfindreplace
export const OPEN_FIND_REPLACE_POPOVER = SharedTrackingEvents.OPEN_FIND_REPLACE_POPOVER;
export const SHOW_REPLACE = SharedTrackingEvents.SHOW_REPLACE;
export const REPLACE_TEXT_ALL = SharedTrackingEvents.REPLACE_TEXT_ALL;

// hshr
export const INSERT_HORIZONTAL_RULE = 'insert-horizontal-rule';

// hsmore
export const DRAG_READ_MORE = 'drag-read-more';

// hsnonbreaking
export const INSERT_NONBREAKING_SPACE = 'insert-nonbreaking-space';

// hscharmap
export const INSERT_SPECIAL_CHARACTER = SharedTrackingEvents.INSERT_SPECIAL_CHARACTER;
export const OPEN_SPECIAL_CHARACTER = SharedTrackingEvents.OPEN_SPECIAL_CHARACTER;

// hsicon
export const EDIT_ICON = SharedTrackingEvents.EDIT_ICON;
export const INSERT_ICON = SharedTrackingEvents.INSERT_ICON;
export const COMMANDS_TO_TRACK = {
  bold: SharedTrackingEvents.CHANGE_INLINE_STYLE,
  italic: SharedTrackingEvents.CHANGE_INLINE_STYLE,
  underline: SharedTrackingEvents.CHANGE_INLINE_STYLE,
  copy: 'cut',
  cut: 'copy',
  indent: 'indent',
  insertunorderedlist: SharedTrackingEvents.MAKE_UNORDERED_LIST,
  insertorderedlist: SharedTrackingEvents.MAKE_ORDERED_LIST,
  justifycenter: 'align-center',
  justifyleft: 'align-left',
  justifyright: 'align-right',
  justifynone: 'remove-alignment',
  mcehsmore: 'insert-read-more',
  // 'mceInsertClipboardContent',
  mcetoggleformat: SharedTrackingEvents.CHANGE_INLINE_STYLE,
  outdent: 'outdent',
  redo: 'redo',
  removeformat: 'remove-formatting',
  selectall: 'select-all',
  undo: 'undo'
};
export const EVENTS_TO_TRACK = {
  pasteFromWord: 'paste-from-word',
  paste: PASTE_CONTENT,
  pastePreProcess: 'pastePreProcess'
};